import { UserGetResponse } from '@lio/api-types';
import { ClockFormat } from '@lio/rule-engine';

export interface IUserRole {
  payerAccountType: ('Agency' | 'Customer')[];
  isAdmin: boolean;
  hasPayerProfile: boolean;
  isPortalAdmin: boolean;
  isUnderwriter: boolean;
  isLIOContractor: boolean;
  isBroker: boolean;
  isJrOps: boolean;
  isSrOps: boolean;
  isCSR: boolean;
  isLioSales: boolean;
  isInternalUser: boolean;
  isInternalWithoutSales: boolean;
  isCustomerUser: boolean;
}

interface IUserRoleExtended extends IUserRole {
  isAuthenticated: boolean;
  isError: boolean;
  isLoading: boolean;
}

export enum GridColumn {
  SINGLE_COLUMN = 'single',
  TWO_COLUMN = 'two',
  OFFERING_DEFAULT = 'default',
}

export enum FontSize {
  SMALL = 'small',
  DEFAULT = 'default',
  LARGE = 'large',
  EXTRA_LARGE = 'extraLarge',
}

export enum OfferingThemeMode {
  DEFAULT = 'default',
  DARK = 'dark',
}

export type TLayoutPreferences = {
  clockFormat: ClockFormat;
  offeringGridColumns: GridColumn;
  offeringColorMode: OfferingThemeMode;
  fontSize: FontSize; // only changes quote details for now - maybe more later
};

export type TWalkthroughs = {
  requireBeforeBind?: boolean;
  // FormsV2 Admin walkthroughs — keys mirror WalkthroughKey in
  // src/pages/PortalAdmin/FormsV2Admin/Walkthroughs/types.ts. Stored on the user's
  // displayPreferences.walkthroughs and used to swap "Start" → "Replay".
  formConflict?: boolean;
  newEdition?: boolean;
  newVersionOfferingOverride?: boolean;
  fullForm?: boolean;
  buildARule?: boolean;
  browseCatalog?: boolean;
  compareEditions?: boolean;
  intensiveEdition?: boolean;
  resolutionSimulator?: boolean;
  jiraTicketsTour?: boolean;
  packagesTour?: boolean;
  conflictsTour?: boolean;
  // First-visit onboarding tour. Auto-launched once on first FormsV2 Admin
  // mount when undefined; never appears in the Walkthroughs list; not
  // replayable. Marked true on either finish OR skip so dismissers aren't
  // pestered next visit.
  whatsNew?: boolean;
};

export type UserStoreSlice = {
  currentUser: UserGetResponse | undefined;
  roles: string[];
  userAuth: IUserRoleExtended;
  setUserRoles: (v: any) => void;
  impersonation?: {
    userOriginalAuthState: {
      roles: string[];
      userAuth: IUserRoleExtended;
    };
    viewingAs: string;
  };

  //   custom user preferences options FUTURE: store on actual user record
  layoutPreferences: TLayoutPreferences;
  setLayoutPreferences: (layoutPreferences: TLayoutPreferences) => void;

  walkthroughs: TWalkthroughs;
  setWalkthroughs: (walkthroughs: TWalkthroughs) => void;
};
